import { Observable } from 'rxjs/Observable';
import { ITunnelResultInterface } from '../interfaces/tunnel-result.interface';
import { EmitterTypes } from '../constants/emitter-types.enum';
import { TunnelResult } from './tunnel-result';
import { Subject } from 'rxjs/Subject';
import { EmitType } from '../constants/emit-types.enum';

export abstract class LayoutTunnels {
  protected subscribeList: Map<string, Subject<TunnelResult>> = new Map<string, Subject<TunnelResult>>();

  constructor() {
  }

  /**
   * Register new observable
   * @param name
   * @returns {Observable<T>}
   */
  registerObservable(name): Observable<TunnelResult> {
    if (!this.subscribeList.has(name)) {
      const observable = <Subject<TunnelResult>> new Subject();
      this.subscribeList.set(name, observable);
      return observable.asObservable();
    } else {
      return this.subscribeList.get(name).asObservable();
    }
  }

  /**
   * returning the observable of the popup
   * optional - register an observable if not found
   *
   * @param {string} name
   * @param {boolean} shouldCreateObservable
   * @return {any}
   */
  getObservable(name: string, shouldCreateObservable: boolean = false): Observable<TunnelResult> {
    if (!this.subscribeList.has(name)) {
      if (shouldCreateObservable) {
        return this.registerObservable(name);
      }
      else {
        console.error(`Tunnel name ${name} has not found`);
        return Observable.throw(`tunnel not found`);
      }
    }

    return this.subscribeList.get(name).asObservable();
  }

  /**
   * returns Observable to subscribe to
   * @param componentToLoad - component instance
   * @param payload
   * @param name
   * @returns {any}
   */
  showLayout(componentToLoad: any,
             payload: any = null,
             name: string): Observable<any> {
    let observable;
    if (!this.subscribeList.has(name)) {
      console.error(`Tunnel name ${name} has not found`);
      return Observable.throw(`tunnel not found`);
    }

    observable = this.subscribeList.get(name);
    observable.next(new TunnelResult(EmitterTypes.loader, EmitType.Open, {
      componentToLoad,
      payload,
    }));

    return observable.asObservable();
  }

  /**
   * returns Observable to subscribe to
   * @param name
   * @returns {any}
   */
  hideLayout(name: string): Observable<any> {
    let observable;
    if (!this.subscribeList.has(name)) {
      console.error(`Tunnel name ${name} has not found`);
      return Observable.throw(`tunnel not found`);
    }

    observable = this.subscribeList.get(name);
    observable.next(new TunnelResult(EmitterTypes.loader, EmitType.Dismiss, { }));

    return observable.asObservable();
  }

  /**
   * Emit next to the given observable
   * @param {string} name
   * @param {ITunnelResultInterface} emitData
   * @param {EmitterTypes} emitter
   * @param {boolean} shouldDismiss
   */
  next(name: string, emitData: ITunnelResultInterface, emitter: EmitterTypes, shouldDismiss: boolean = false): void {
    if (!this.subscribeList.has(name)) {
      console.error(`Tunnel name ${name} has not found`);
      return;
    }
    const observable = this.subscribeList.get(name);
    observable.next(new TunnelResult(emitter, EmitType.Data, emitData));
    if (shouldDismiss) { this.dismissObservable(name); }
  }

  /**
   * Dismiss observable and remove it from subscribe list
   * @param name
   * @param shouldEmit
   * @param emitter
   * @param payload
   */
  dismissObservable(name: string, shouldEmit: boolean = false, emitter: EmitterTypes = EmitterTypes.parent, payload?: ITunnelResultInterface): void {
    if (!this.subscribeList.has(name)) {
      console.error(`Tunnel name ${name} has not found`);
      return;
    }
    const observable = this.subscribeList.get(name);
    if (observable) {
      this.subscribeList.delete(name);
      if (shouldEmit) {
        observable.next(new TunnelResult(emitter, EmitType.Dismiss, payload));
      }
      observable.complete();
      this.subscribeList.delete(name);
    }

  }


}
